
import defineComponent from 'flight'

function BinFormUI() {
    this.defaultAttrs({
        shippingOptionSelector: '[data-bin-form-shipping]',
        totalPriceSelector: '[data-bin-form-list-total]',
        itemPriceSelector: '[data-bin-form-price]',
        selectedShippingSelector: '[data-bin-form-selected-shipping]',
        invoiceFeeSelector: '[data-bin-form-invoice-fee]'
    });

    this._updateShippingAndTotal = function () {
        let itemPrice = parseInt(this.select('itemPriceSelector').html(), 10),
            shippingOptions = this.select('shippingOptionSelector'),
            shippingFee = shippingOptions.find(':selected').data('shipping-fee'),
            invoiceFee = this.select('invoiceFeeSelector').html() ? (parseInt(this.select('invoiceFeeSelector').html().replace(' ', ''), 10) || 0) : 0,
            totalPrice = itemPrice + shippingFee + invoiceFee;

        this.select('totalPriceSelector').text(totalPrice);
        this.select('selectedShippingSelector').text(shippingFee);
        this.trigger(document, 'ui:checkout:on-shipping-option-change');
    };

    this.after('initialize', function () {
        this.on('change', {
            shippingOptionSelector: this._updateShippingAndTotal
        });
    });
}

export default defineComponent.component(BinFormUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/bin-form-ui.js